import DollarTagIcon from '../../../../../icons/dollar-tag.svg?react';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg?react';
import UserIcon from '../../../../../icons/user.svg?react';
import DocumentIcon from '../../../../../icons/document.svg?react';

export default function PurchasingProcessData() {
    return {
        image: "/product-landing/term/circle1.png",
        steps: [
            {
                title: "Request a Quote",
                icon: DollarTagIcon,
                paragraphs: [
                    "Covr makes it easy! After you have entered the best way to contact you, one of our insurance experts will be able to assess your needs and make an appropriate recommendation",
                ]
            },
            {
                title: "Choose the best options",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "Covr will help you understand your options and make the right decisions. Options would include the policy limit, monthly benefit amount, and the waiting period before your policy begins.",
                ]
            },
            {
                title: "Select and Apply",
                icon: UserIcon,
                paragraphs: [
                    "After you choose the best options for you, one of our insurance experts will be able to walk you through the application process.",
                ]
            },
            {
                title: "Finish your Underwriting Process",
                icon: DocumentIcon,
                paragraphs: [
                    "We will work directly with the carrier to get you an offer. Keep an eye on your inbox as we will keep you in the loop from start to finish.",
                ]
            }
        ]
    }
}